import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Select from '../../../components/global/Select';

const propTypes = {
  className: PropTypes.string,
  visible: PropTypes.bool,
};

const DesignerViewSecondaryC = ({ className, visible }) => {
  const classes = classNames({
    [className]: !!className,
  });

  if (!visible) {
    return null;
  }

  return (
    <div className={classes}>
      <p>DesignerViewSecondaryC</p>
      <Select id="random-select" label="Make a choice" labelSrOnly>
        <option value="">Select something</option>
        <option value="1">Value 1</option>
        <option value="2">Value 2</option>
      </Select>
    </div>
  );
};

DesignerViewSecondaryC.propTypes = propTypes;

export default DesignerViewSecondaryC;
